/**
 * 작성자 : 박승호
 * 날짜 : 2024.08.23
 * 기능 : 목록 펼치기/접기 기능이 있는 토글버튼 // 스타일 유형 2
 */

import React from 'react';
import styled from 'styled-components';

const SubExpandButtonStyle = styled.button`
  all: unset;
  cursor: pointer;
  user-select: none;
  background-color: var(--board);
  border-radius: 50%;

  &.disabled {
    cursor: not-allowed;
    pointer-events: none;
    opacity: 0.5;
  }
  &.margin-05 {
    margin: 0 0.5rem;
  }
  .material-symbols-rounded {
    font-variation-settings: 'FILL' 1;
  }
  .expandIcon {
    font-size: 24px;
    width: 2rem;
    height: 2rem;
    display: flex;
    justify-content: center;
    align-items: center;
    color: var(--text-disabled);
    transform: rotate(0);

    &.expand-up {
      transform: rotate(-180deg);
    }
  }
  &:hover {
    background-color: var(--board);
    outline: 3px solid var(--primary);
    .material-symbols-rounded {
      color: var(--filled-blue-deep);
    }
    &:active {
      outline: 2px solid var(--primary);
      transform: scale(0.95);
    }
  }
`;

const SubExpandButton = ({
  isExpanded,
  onClickExpandButton,
  disabled,
  className,
}: {
  isExpanded: boolean;
  onClickExpandButton: (e: React.MouseEvent<any>) => void;
  disabled?: boolean | undefined;
  className?: string;
}) => {
  const style = `${disabled ? 'disabled' : ''} ${className ?? ''}`;
  return (
    <SubExpandButtonStyle type='button' onClick={onClickExpandButton} className={style}>
      <span className={`material-symbols-rounded expandIcon ${isExpanded && 'expand-up'}`}>expand_circle_down</span>
    </SubExpandButtonStyle>
  );
};
export default SubExpandButton;
